import { cookies } from "../helpers/cookies";

class ConsentService {
    public isAnalyticsGranted() {
        return cookies.get("TC_PRIVACY_CENTER")?.includes('15');
    }
}

export const consentService = new ConsentService();
